/**
 * Comment Service
 * Handles all comment/discussion related API calls
 *
 * @module services/CommentService
 */

import BaseService from "core/api/BaseService";

class CommentService extends BaseService {
  constructor() {
    super("/comments");
  }

  async getByItem(itemType, itemId) {
    return this.get(`${itemType}/${itemId}`);
  }

  async create(commentData) {
    return this.post("", commentData);
  }

  async update(commentId, commentData) {
    return this.put(`${commentId}`, commentData);
  }

  async delete(commentId) {
    return this.deleteCustom(`/${commentId}`);
  }

  async reply(commentId, replyData) {
    return this.post(`${commentId}/reply`, replyData);
  }

  async toggleLike(commentId) {
    return this.post(`${commentId}/like`);
  }
}

export default new CommentService();
